"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAdminUpdateHaulerTransport = exports.HaulerTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const address_transport_1 = require("../common/address-transport");
const currency_1 = require("../stripe-handler/currency");
const dumpster_size_transport_1 = require("./dumpster-size-transport");
const hauler_payment_processor_account_transport_1 = require("./hauler-payment-processor-account-transport");
const hauler_preferences_transport_1 = require("./hauler-preferences-transport");
const hauler_terms_of_service_transport_1 = require("./hauler-terms-of-service-transport");
const hauler_vendor_1 = require("./hauler-vendor");
const licenseTransport_1 = require("./licenseTransport");
const yard_transport_1 = require("./yard-transport");
exports.HaulerTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    ein: typebox_1.Type.Optional(typebox_1.Type.String({ description: 'Employer Identification Number in format XX-XXXXXXX' })),
    licences: typebox_1.Type.Optional(typebox_1.Type.Array(licenseTransport_1.LicenseTransport)),
    contactEmail: typebox_1.Type.String(),
    name: typebox_1.Type.String(),
    contactPhoneNumber: typebox_1.Type.String(),
    billingAddress: address_transport_1.AddressTransport,
    yards: typebox_1.Type.Array(yard_transport_1.YardTransport),
    website: typebox_1.Type.Optional(typebox_1.Type.String()),
    isSourgumPartner: typebox_1.Type.Boolean(),
    preferences: typebox_1.Type.Array(hauler_preferences_transport_1.HaulerPreferenceTransportValidation),
    defaultRentPeriod: typebox_1.Type.Optional(common_1.Duration),
    maxRentalPeriod: typebox_1.Type.Optional(common_1.Duration),
    rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    dumpsterSizes: typebox_1.Type.Array(dumpster_size_transport_1.DumpsterSizeTransport),
    materials: typebox_1.Type.Array(typebox_1.Type.String()),
    statementDescriptorSuffix: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeSubscriptionID: typebox_1.Type.Optional(typebox_1.Type.String()),
    applicationFeePercent: typebox_1.Type.Optional(typebox_1.Type.Number({ description: 'stored as int Basis points: 500 = 5%' })),
    applicationFeeFlat: typebox_1.Type.Optional(typebox_1.Type.Number({ description: 'stored as int in cents: 500 = $5.00' })),
    billingEnabled: typebox_1.Type.Boolean(),
    billingEnabledDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    logo: typebox_1.Type.Optional(common_1.S3ItemReference),
    waysteLite: typebox_1.Type.Boolean(),
    checkoutEnabled: typebox_1.Type.Boolean(),
    checkoutEnabledDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutShortID: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutLogo: typebox_1.Type.Optional(common_1.S3ItemReference),
    checkoutLogoURL: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutLink: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkoutTermsOfService: typebox_1.Type.Optional(hauler_terms_of_service_transport_1.HaulerToSTransport),
    sourgumVendorNumber: typebox_1.Type.Integer(),
    currency: currency_1.Currency,
    timeZone: typebox_1.Type.String(),
    vendorStatus: typebox_1.Type.Optional(hauler_vendor_1.HaulerVendorStatusSchema),
    paymentProcessorAccounts: typebox_1.Type.Array(hauler_payment_processor_account_transport_1.HaulerPaymentProcessorAccountTransport),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.AppAdminUpdateHaulerTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(typebox_1.Type.Partial(exports.HaulerTransport), ['metadata', 'paymentProcessorAccounts']),
    typebox_1.Type.Partial(typebox_1.Type.Object({
        stripeSubscriptionID: typebox_1.Type.Optional(typebox_1.Type.String()),
        paymentProcessorAccount: typebox_1.Type.Optional(hauler_payment_processor_account_transport_1.HaulerPaymentProcessorAccountUpsertTransport),
    })),
]);
//# sourceMappingURL=hauler-transport.js.map